var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.7,
    height: 152.22,
    viewBox: "0 0 170.7 152.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e8d1b3;}.a,.b,.c,.d,.e,.f,.g,.h,.i,.j{fill-rule:evenodd;}.b{fill:#16232c;}.c{fill:#adadad;}.d{fill:#dedede;}.e{fill:#6d8aa2;}.f{fill:#d81212;}.g{fill:#ffd9c9;}.h{fill:#6f6571;}.i{fill:#d9d9d9;}.j{fill:#cbc7cb;}.k{fill:#4caf50;}.l{fill:#339137;}.m{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-54 -89.91)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54 89.91)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M382.021,228.265h40.95v14.226a6.4,6.4,0,0,1-6.385,6.39h-14.73l-8.786,4.438-11.05-4.438V228.265Z",
    transform: "translate(-261.664 -160.893)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M388.407,162.742h28.18a6.4,6.4,0,0,1,6.385,6.39V179.7h-40.95v-10.57A6.4,6.4,0,0,1,388.407,162.742Z",
    transform: "translate(-261.664 -116.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M382.022,206.463h40.95v10.045h-40.95Z",
    transform: "translate(-261.664 -145.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M276.1,293.7h19.836v9.125a3.989,3.989,0,0,1-3.974,3.978H227.377c0-5.736,0-8.655,4.388-8.655l8.74-.009c5.5-.009,9.108-1.418,11.123-4.438H276.1Z",
    transform: "translate(-155.741 -205.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M177.115,335.289h56.793c3.33,5.8,6.008,12.771,3.7,26.1-3.864-13.148-43.112-7.9-47.142,7.274H147.159c-1.638-3.711-3.183-7.375-4.536-11.077h12.209c24.693-9.318,16.754-5.166,22.283-22.3Z",
    transform: "translate(-97.689 -234.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M237.791,149.021a92.707,92.707,0,0,0,3.284,12.587l12.484,4.892,13.92-4.892c-.488-26.343-10.332-38.976-18.7-43.064a20.324,20.324,0,0,0-6.109-3.163s-4.066,6.506-4.278,6.506c-1.564,3.72-2.153,8.572-2.052,13.811Z",
    transform: "translate(-161.871 -83.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M248.323,262.108h-26.4c-6.081.663-13.561,5.294-13.561,19.64v15.036l5.992,3.569,7.789-3.569v-11.62c0-5.736,0-8.655,4.388-8.655l8.74-.009c5.5-.009,9.108-1.418,11.123-4.438,1.555-2.329,2.153-5.616,1.933-9.953Z",
    transform: "translate(-142.713 -184.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M294.474,388.044a24.075,24.075,0,0,1,47.142-7.274,24.689,24.689,0,0,1,1.058,6.5c.028.884-.58.773-1.408.773q-23.391,0-46.792,0Z",
    transform: "translate(-201.699 -253.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M313.718,441.231h36.69a18.355,18.355,0,0,1-36.69,0Z",
    transform: "translate(-214.88 -306.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.083,428.81l31.566,7.265a16.2,16.2,0,1,1-31.566-7.265Z",
    transform: "translate(-11.416 -298.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.3,379.949a22.032,22.032,0,0,1,20.3-9.447c14.279,3.02,18.925,11.556,19.854,22.2a22,22,0,0,1-.488,4.355c-.092.405-.359.239-.8.138l-4.941-1.133L5.667,388.8,3.3,388.255,0,387.49a21.857,21.857,0,0,1,3.3-7.541Z",
    transform: "translate(0 -258.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M74.845,269.112,87.6,224.989l5.741-2.569,6.422,2.569c-8.437,23.387-6.081,39.712-.386,55.292,1.362,3.7,2.907,7.366,4.536,11.077H94.736Z",
    transform: "translate(-51.265 -156.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M198.06,66.62l14.96-3.186c1.518.138,5.861,3.784,5.861,6.068L215.7,85.689a14.611,14.611,0,0,1-4.186.617A14.465,14.465,0,0,1,198.06,66.62Z",
    transform: "translate(-134.992 -47.993)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M184.849,33.05a18.221,18.221,0,1,1,36.433,0c0,6.8-2.76,12.835-7.765,16.343a17.378,17.378,0,0,1-6.2,2.726V35.932c0-2.284-1.159-2.744-2.677-2.882H184.849Z",
    transform: "translate(-126.611 -14.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M189.83,372.171h13.782v8.683c0,1.86-1.012,2-2.5,2h-19.78C180.933,374.141,186.2,372.171,189.83,372.171Z",
    transform: "translate(-124.187 -259.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M99.319,185.155l17.214,5.69c.847.755-.11,8.453-.681,8.2H95.841v-12.67c0-2.5,1.3-1.943,3.478-1.225Z",
    transform: "translate(-65.646 -130.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M160.505,211.337h-8.7c-4.674,0-4.812-7.753.681-8.2l8.023-.645,2.153,4.558Z",
    transform: "translate(-101.596 -143.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M202.539,170.351l2.88-2.477c7.213-6.215,16.33,4.272,6.689,10.534l-8.115,5.267-4.085,2.652H186.981v-8.849l8.032-.654Z",
    transform: "translate(-128.072 -118.227)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M238.536,219.771Z",
    transform: "translate(-162.615 -154.323)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 20.779,
    cy: 19.831,
    rx: 20.779,
    ry: 19.831,
    transform: "translate(183.142 124.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M243.307,128.917a22,22,0,0,0-2.307.122c10.518,1.122,18.471,9.608,18.471,19.708S251.518,167.333,241,168.455a21.981,21.981,0,0,0,2.307.122c11.476,0,20.779-8.878,20.779-19.831s-9.3-19.831-20.779-19.831Z",
    transform: "translate(-39.387 -4.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M10.835,13.792a1.81,1.81,0,0,0-2.352,0,1.371,1.371,0,0,0,0,2.1l4.968,4.428a1.766,1.766,0,0,0,1.176.428,1.744,1.744,0,0,0,1.192-.5L27.412,8.434a1.366,1.366,0,0,0-.2-2.034,1.8,1.8,0,0,0-2.288.086l-10.3,10.627Z",
    transform: "translate(185.674 131.325)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus8);
export default __webpack_public_path__ + "static/media/status-8.64abfca579ad7f2069d7e51ad9dda771.svg";
export { ForwardRef as ReactComponent };